export default __webpack_public_path__ + "static/media/3021.68af990a.jpg";